import React from 'react';
import { Link } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import FormField from '../../../forms/FormField';

const required = value => value ? undefined : 'Required';

const passwordMatch = (...props) => {
  const { password, password2 } = props[1] || {};

  return password !== password2 ? 'Passwords do not match.' : undefined;
};

const passwordLength = (...props) => {
  const { password } = props[1] || {};
  return password.length < 8
    ? 'Password must be at least 8 characters long.'
    : undefined;
};

const checkError = error => {
  const { jsonData } = error || {};
  const { json } = jsonData || {};
  const { message } = json || {};

  if (!message) return;

  switch (message) {
    default:
      return 'Generic';
  }
};

const EditPasswordForm = (
  {
    handleSubmit,
    submitting,
    errorSubmit,
    toggle
  }
) => {
  const formSubmitError = checkError(errorSubmit);

  return (
    <div className="row">
      <div className="col-md-6">
        <p className="account-info-block last">
          <strong>Change Your Password</strong>
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="col-md-6">
              <Field
                name="password"
                type="password"
                component={FormField.Input}
                placeholder="Enter Password"
                validate={[required]}
              />
            </div>
            <div className="col-md-6">
              <Field
                name="password2"
                type="password"
                component={FormField.Input}
                placeholder="Re-enter Password"
                validate={[required, passwordMatch, passwordLength]}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-6">
              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={submitting}
              >
                Submit
              </button>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-inverse btn-block"
                onClick={() => toggle('password')}
                disabled={submitting}
              >
                Cancel
              </button>
            </div>
          </div>
          {formSubmitError === 'Generic' &&
            <div className="form-row">
              <span style={{ color: '#dc3545', marginLeft: '10px' }}>
                An error occured trying update your Password.
              </span>
            </div>}
        </form>
      </div>
    </div>
  );
};

const formName = 'edit-password-form';

const mapState = state => {};

const form = reduxForm({ form: formName })(EditPasswordForm);
export default connect(mapState)(form);
